export default __webpack_public_path__ + "static/media/twitter_darkgray1.f9d88014.svg";